// extracted by mini-css-extract-plugin
export default {"search-input":"user-select_search-input__M9k7Y","--disabled":"user-select_--disabled__XJNeq","all":"user-select_all__H7FdD"};